<template>
  <div class="align-icon">
    <div v-for="deskSlot in orderedDeskSlots" :key="deskSlot.id">
      <v-menu
        offset-y
        close-on-click
        close-on-content-click
        aria-label="crud-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs" aria-label="desk-slot-icon">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon v-on="on" aria-label="slot-icons">{{
                  slotType(deskSlot.categoryName)
                }}</v-icon>
              </template>
              <span>{{
                $t("crudDeskSlots.contain") +
                " " +
                deskSlot.quantity +
                " " +
                deskSlot.categoryName.toLowerCase()
              }}</span>
            </v-tooltip>
          </div>
        </template>
        <v-list v-if="editMode">
          <v-list-item>
            <v-list-item-content>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <edit-desk-slot-dialog-button
                    :desk="deskSlot.desk"
                    :deskSlot="deskSlotCopy"
                    @click="copyDeskSlotOf(deskSlot)"
                    icon
                    small
                    v-on="on"
                    aria-label="edit-slot-button"
                  >
                    <template #dialog-button-text>
                      <v-icon> mdi-pencil </v-icon>
                    </template>
                  </edit-desk-slot-dialog-button>
                </template>
                <span>{{ $t("crudCommon.tooltipEdit") }}</span>
              </v-tooltip>
            </v-list-item-content>
            <v-list-item-content>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn
                    icon
                    @click="openDeskSlotDeleteDialog(deskSlot)"
                    v-on="on"
                    aria-label="delete-slot-button"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crudCommon.tooltipDelete") }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div v-if="editMode">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <edit-desk-slot-dialog-button
            :desk="desk"
            :deskSlot="newDeskSlot"
            @closed="clearNewDeskSlot"
            icon
            small
            v-on="on"
            aria-label="add-slot-button"
          >
            <template #dialog-button-text>
              <v-icon>{{ "mdi-plus-circle" }}</v-icon>
            </template>
          </edit-desk-slot-dialog-button>
        </template>
        <span>{{ $t("roomsList.tooltipAdd") }}</span>
      </v-tooltip>
      <v-dialog v-model="deleteDeskSlotDialogOpen" max-width="500px">
        <v-card class="card-delete">
          <v-card-title>{{ $t("crudDesks.deleteConfirm") }}</v-card-title>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="F44336"
              text
              @click="closeDeskSlotDeleteDialog"
              aria-label="cancel-btn"
            >
              {{ $t("crudCommon.cancel") }}
            </v-btn>
            <v-btn
              color="F44336"
              text
              @click="confirmDeskSlotDeleteDialog"
              aria-label="delete-confirm-btn"
            >
              {{ $t("crudCommon.delete") }}
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import EditDeskSlotDialogButton from "../../crud/deskSlot/EditDeskSlotDialogButton.vue";

export default {
  components: { EditDeskSlotDialogButton },
  name: "DeskSlotIcon",
  props: {
    desk: null,
    editMode: null,
  },
  computed: {
    ...mapGetters("deskSlotModule", {
      deskSlotsByDeskId: "getDeskSlotsByDeskId",
    }),
    newDeskSlot() {
      return {
        deskId: this.desk.id,
      };
    },
    deskSlots() {
      return this.deskSlotsByDeskId(this.desk.id);
    },
    orderedDeskSlots() {
      let sortedSlots = this.deskSlots;
      sortedSlots = sortedSlots.sort((a, b) => {
        let catA = a.categoryName,
          catB = b.categoryName;
        if (catA < catB) {
          return -1;
        }
        if (catA > catB) {
          return 1;
        }
        return 0;
      });
      return sortedSlots;
    },
  },
  data() {
    return {
      deskSlotCopy: null,
      deleteDeskSlotDialogOpen: false,
      deskSlotToDelete: null,
    };
  },
  methods: {
    ...mapActions("deskSlotModule", ["editDeskSlot", "deleteDeskSlot"]),
    slotType(item) {
      let path;
      if (item.includes("ECRAN")) {
        path = "mdi-monitor-dashboard";
      } else if (item.includes("CLAVIER")) {
        path = "mdi-keyboard";
      } else if (item.includes("SOURIS")) {
        path = "mdi-mouse";
      } else if (item.includes("CASQUE")) {
        path = "mdi-headset";
      } else if (item.includes("POSTE")) {
        path = "mdi-desk";
      } else {
        path = "mdi-semantic-web";
      }
      return path;
    },
    getDeskSlots() {
      return this.$emit("getSlots");
    },
    clearNewDeskSlot() {
      this.newDeskSlot = {};
    },
    copyDeskSlotOf(deskSlot) {
      this.deskSlotCopy = structuredClone(deskSlot);
    },
    openDeskSlotDeleteDialog(deskSlot) {
      this.deskSlotToDelete = deskSlot;
      this.deleteDeskSlotDialogOpen = true;
    },
    closeDeskSlotDeleteDialog() {
      this.deleteDeskSlotDialogOpen = false;
    },
    confirmDeskSlotDeleteDialog() {
      this.deleteDeskSlot(this.deskSlotToDelete);
      this.closeDeskSlotDeleteDialog();
    },
  },
};
</script>
<style>
.align-icon {
  display: flex;
  flex-direction: row;
}
</style>
